import { Provider } from '@angular/core';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { oktaApp } from '../../../../environments/environment';

export function provideAuth(): Provider[] {
  return [
    {
      provide: OktaAuth,
      useFactory: () => new OktaAuth({
        ...oktaApp.oidc,
        // Add additional options for better logout handling
        transformErrorXHR: (xhr: any) => {
          // Handle CORS and other network errors more gracefully
          if (xhr.status === 0) {
            return {
              name: 'NetworkError',
              message: 'Network error occurred during authentication'
            };
          }
          return xhr;
        }
      })
    },
    {
      provide: OKTA_CONFIG,
      useFactory: (oktaAuth: OktaAuth) => ({
        oktaAuth,
        onAuthRequired: async (oktaAuth: OktaAuth) => {
          // Clear any stale tokens before redirecting
          oktaAuth.tokenManager.clear();
          await oktaAuth.signInWithRedirect();
        }
      }),
      deps: [OktaAuth]
    }
  ];
}
